import React from 'react';
import { Empty } from 'antd';
import SpinnerChidori from 'components/SpinnerChidori/SpinnerChidori';
import { DetailedSparkJobDTO } from 'types/types';
import {
  formatCode,
  detectSyntaxLabel,
  getLangPillColor,
  highlightSQL,
} from 'components/JobsTable/JobsDetailsSidebar/JobDetailsSidebarHelpers';
import '../JobCodeModal.scss';

type JobCodeContentProps = {
  job: DetailedSparkJobDTO | undefined;
  isLoading: boolean;
  style?: React.CSSProperties;
};

export const JobCodeContent: React.FC<JobCodeContentProps> = ({
  job,
  isLoading,
  style,
}) => {
  if (isLoading) {
    return (
      <div className="job-code__centered">
        <SpinnerChidori />
      </div>
    );
  }

  if (!job) {
    return (
      <Empty
        description="No job selected"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  if (!job.code) {
    return (
      <Empty
        description="Error fetching job code"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  const langStyle = getLangPillColor(job.mvLanguage);
  const codeString = formatCode(job.code);
  const syntaxLabel = detectSyntaxLabel(codeString);

  return (
    <div className="job-code__body" style={style ? { height: '915px' } : {}}>
      <div className="job-code__header">
        {job.mvLanguage && (
          <span
            className="job-code__lang-pill"
            style={
              {
                '--lang-bg': langStyle.bg,
                '--lang-color': langStyle.color,
              } as React.CSSProperties
            }>
            {job.mvLanguage}
          </span>
        )}
      </div>
      <div className="job-code__code-wrapper">
        <span className="job-code__syntax-label">{syntaxLabel}</span>
        <pre className="job-code__pre" style={style}>
          {highlightSQL(codeString)}
        </pre>
      </div>
    </div>
  );
};

export default JobCodeContent;
